import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import { isInEnum } from '@thesavingsgroup/utils/isInEnum';

import { HydrateSource } from '../enums/HydrateSource';
import { HydrateFromSignUp } from '../types/HydrateFromSignUp';

/**
 * Maps the URL of an `/apply` request to hydration parameters, or `null` if
 * the request did not arrive with any.
 */
export const toApplyEntryParameters = (
  url: string,
): HydrateFromSignUp | null => {
  const { pathname, searchParams } = new URL(url);

  // only the workflow entry point itself carries hydration parameters. workflow steps
  // are reached through in-app navigation, which never appends a query string
  if (pathname.replace(/\/$/, '') !== '/apply') {
    return null;
  }

  const applicationType = searchParams.get('applicationType');
  const vin = searchParams.get('vehicle_vin');

  if (!applicationType && !vin) {
    return null;
  }

  return {
    applicationType: isInEnum(applicationType, ApplicationType)
      ? applicationType
      : null,
    source: HydrateSource.SIGN_UP,
    vin,
  };
};
